import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 420px;
  max-width: calc(100vw - 32px);
  background-color: var(--color-white);
  border-radius: 12px;
  padding: 16px 16px 16px;
  outline: none;
`

export const HeaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 10px;
  min-height: 32px;
`

export const Title = styled.h2`
  margin: 0;
  flex: 1;
  font-size: 20px;
  font-weight: 700;
  font-family: 'Lato', sans-serif;
  color: rgba(46, 46, 50, 1);
  line-height: 1.2;
`

export const Description = styled.p`
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: rgba(97, 101, 129, 1);
`

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
`

export const Divider = styled.div`
  margin: 0 -16px;
  border-top: 1px solid var(--color-issabeline-grey);
`

export const ButtonsWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 12px;
`

export const CancelButton = styled.button`
  padding: 4px 20px;
  border: 1px solid rgba(0, 160, 227, 1);
  border-radius: 8px;
  background: var(--color-white);
  color: rgba(0, 160, 227, 1);
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`

export const ConfirmButton = styled.button`
  padding: 4px 20px;
  border: none;
  border-radius: 8px;
  background: rgba(0, 160, 227, 1);
  color: var(--color-text-on-primary);
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`
